import { PayloadAction, createSlice } from '@reduxjs/toolkit';

import { queryStringOrSessionStorage } from 'src/utils/queryStringOrSessionStorage';

export type CustomerState = {
    customerId?: number | string;
};

const initialState: CustomerState = {
    customerId: queryStringOrSessionStorage('customerId')!,
};

export const customerSlice = createSlice({
    name: 'customer',
    initialState,
    reducers: {
        setCustomerId: (state, action: PayloadAction<string | number>) => {
            state.customerId = action.payload;
        },
    },
});

export const { setCustomerId } = customerSlice.actions;

export default customerSlice.reducer;
